
import React from 'react';

export function MetricsStyles() {
  const highlightStyles = `
  .highlight-section {
    animation: highlight 1.5s ease;
  }

  .metric-card {
    transition: all 0.2s ease-in-out;
  }

  .metric-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .dark .metric-card:hover {
    box-shadow: 0 10px 20px -3px rgba(0, 0, 0, 0.5), 0 4px 8px -2px rgba(0, 0, 0, 0.3);
  }

  @keyframes highlight {
    0% { box-shadow: none; }
    30% { box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.4); }
    100% { box-shadow: none; }
  }

  .dark @keyframes highlight {
    0% { box-shadow: none; }
    30% { box-shadow: 0 0 0 4px rgba(139, 159, 255, 0.5); }
    100% { box-shadow: none; }
  }

  /* Scrollbar customizada HostVSL para conteúdo de métricas */
  .metrics-content-scroll::-webkit-scrollbar {
    width: 8px;
  }

  .metrics-content-scroll::-webkit-scrollbar-track {
    background: transparent;
  }

  .metrics-content-scroll::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, #6A5CFF 0%, #584DE0 100%);
    border-radius: 8px;
  }

  .metrics-content-scroll::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(180deg, #584DE0 0%, #4A3CE6 100%);
  }

  /* Firefox */
  .metrics-content-scroll {
    scrollbar-width: thin;
    scrollbar-color: #6A5CFF transparent;
  }

  /* Dark mode scrollbar para métricas */
  .dark .metrics-content-scroll::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, #8B9FFF 0%, #6A7DE0 100%);
  }

  .dark .metrics-content-scroll::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(180deg, #A0B3FF 0%, #8B9FFF 100%);
  }

  .dark .metrics-content-scroll {
    scrollbar-color: #8B9FFF transparent;
  }
  `;

  return <style>{highlightStyles}</style>;
}
